import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useOrderStore = defineStore(
  'order',
  () => {
    const orderQuery = ref<any>({})
    const orderInfo = ref<any>(null)

    const setOrderQuery = (data:any) => {
        orderQuery.value = {...orderQuery.value,...data}
    }

    const setOrderInfo = (data: any) => {
        orderInfo.value = { ...(orderInfo.value || {}), ...data }
    }
    
    const removeOrderInfo = () => {
        orderInfo.value = null
    }

    const removeOrderQuery = () => {
        orderQuery.value = {}
    }

    return {orderInfo,orderQuery,setOrderInfo,setOrderQuery,removeOrderInfo,removeOrderQuery}
  },
  { persist: true },
)